module.exports = __webpack_public_path__ + "img/canales.e866cf0b.png";